export const FilesFolders = {
  // Company folders
  CompanyDocuments: 'company_documents',
  CandidatesApplicationDocuments: 'candidates_application_documents',
  ResultFiles: 'result_files',
  Billing: 'billing',
  Consents: 'consents',

  // Region bucket folders
  Assets: 'assets',
  Acic: 'acic',
  Temp: 'tmp',
};
